import { getString } from "../../common/common";

export const HEADING1 = "HEADING1";
export const HEADING2 = "HEADING2";
export const P1 = "P1";
export const HEADING3 = "HEADING3";
export const P2 = "P2";
export const P3 = "P3";
export const P4 = "P4";
export const P5 = "P5";
export const P6 = "P6";
export const P7 = "P7";
export const HEADING4 = "HEADING4";
export const P8 = "P8";
export const HEADING5 = "HEADING5";
export const P9 = "P9";
export const HEADING6 = "HEADING6";
export const P10 = "P10";
export const HEADING7 = "HEADING7";
export const P11 = "P11";
export const HEADING8 = "HEADING8";
export const P12 = "P12";
export const HEADING9 = "HEADING9";
export const P13 = "P13";
export const HEADING10 = "HEADING10";
export const P14 = "P14";
export const HEADING11 = "HEADING11";
export const P15 = "P15";
export const LI1_1 = "LI1_1";
export const LI1_2 = "LI1_2";
export const LI2_1 = "LI2_1";
export const LI2_2 = "LI2_2";
export const LI3_1 = "LI3_1";
export const LI3_2 = "LI3_2";
export const HEADING12 = "HEADING12";
export const P16 = "P16";
export const HEADING13 = "HEADING13";
export const LI4 = "LI4";
export const LI5 = "LI5";
export const LI6 = "LI6";

export const HEADING14 = "HEADING14";
export const P17 = "P17";
export const HEADING15 = "HEADING15";
export const P18 = "P18";

export const translations = {
  en: {
    [HEADING1]: "Labour Welfare",
    [HEADING2]: "Labour Welfare measures implemented in KSRTC",
    [P1]: "KSRTC has introduced many labour welfare measures for the benefit of the employees. Out of them a few major welfare schemes are explained below:",
    [HEADING3]: "De-addiction Centre:",
    [P2]: "A de-addiction programme, WAPPA (Work Place Alcohol Prevention Programme and Activity) was implemented in",
    [P3]: "KSRTC since 1997 as a worker reach out program. The policy objectives are:",
    [P4]: "To prevent alcohol abuse among all employees as a part of the corporations commitment to the health",
    [P5]: "and welfare of its employees, operational safety and the environment.",
    [P6]: "To educate the employees on the dangers and consequences of alcohol abuse specially in the interest of",
    [P7]: "the commuter safety and assist all employees to overcome this habit.",
    [HEADING4]:
      "Preventive Medicine & Healthy Life Style Clinic at Bangalore and Mysore:",
    [P8]: "Established to provide a Comprehensive annual health checkup program for all the employee",
    [HEADING5]: "Insurance Scheme:",
    [P9]: "An internal insurance scheme called KSRTC Employees Family Welfare Scheme with contribution from both employee and the employer is introduced which provides a compensation of Rs.3 lakhs to the dependent of the employee who die while in service.",
    [HEADING6]: "Merit Awards:",
    [P10]:
      "Merit awards for children of employees/officers who secure higher marks in SSLC, PUC & Degree examinations.",
    [HEADING7]: "Educational Loan :",
    [P11]:
      "A scheme of extending educational loan upto a maximum of Rs.1 lakh for coverage of tuition fee to the employees children who are admitted to professional courses.",
    [HEADING8]: "Medical Reimbursement:",
    [P12]:
      "Reimbursement is given on par with State Government. Advance for major illness and personal sickness of the employee and their dependents.",
    [HEADING9]: "Recognition of Hospitals:",
    [P13]:
      "To provide adequate medical facilities to the employees and their dependents more than 108 reputed private hospitals and 7 Diagnostic centers have been recognized by the Corporation.",
    [HEADING10]: "Educational Assistance:",
    [P14]:
      "A Scheme to provide monthly scholarships to children of employees/ officers studying in different courses.",
    [HEADING11]: "Award schemes:",
    [P15]:
      "Awarding Gold and Silver medals to the Accident free Drivers of the corporation.",
    [LI1_1]: "Gold Medal:",
    [LI1_2]:
      "Awarded to the drivers who render accident-free service for a period of fifteen years in mofussil divisions and seven years in city services.",
    [LI2_1]: "Silver Medal:",
    [LI2_2]:
      "Awarded to the drivers with five years accident-free record in mofussil divisions and three years accident-free record in city services.",

    [LI3_1]: "Shourya Prashasti Medal Scheme:",
    [LI3_2]:
      "Shourya Prashasti Medal Scheme has been introduced in KSRTC as per approval of the Board of directors vide resolution N0.9129, dated 25.11.09 to grant cash award upto the maximum of Rs.20,000/- and Gold Medal for meritorious/exemplary services and sacrifice rendered by the employers while discharging their legitimate duties after examining casewise.",
    [HEADING12]: "Sports and Cultural Activities:",
    [P16]:
      "Divisional and inter divisional sports and cultural activities for the employees are held annually.",
    [HEADING13]: "Traffic Revenue Incentive Scheme:",
    [LI4]: "This scheme is applicable to drivers and conductors.",
    [LI5]: "In city and suburban services, 3% of traffic revenue collection.",
    [LI6]:
      "In respect of ordinary, mofussil, express, semi-luxury services, 2% of traffic revenue.",
    [HEADING14]: "Counselling:.",
    [P17]:
      "To motivate the labour force for maximum productivity a counseling scheme is implemented in KSRTC. It helps in reducing absenteeism there by increasing the productivity, reduction in the accident rate and improvement in the behaviour of the employees with the passengers.",

    [HEADING15]: "Voluntary retirement scheme:",
    [P18]:
      "A Voluntary Retirement scheme is implemented from 12.08.2005. Under the scheme an employee who opts for Voluntary Retirement gets an additional financial benefit ranging from Rs.75,000/- to Rs.2,00,000/-. The minimum benefit has been enhanced to Rs.1,25,000/- with effect from October 2010.",
  },
  kn: {
    [HEADING1]: "ಕಾರ್ಮಿಕ ಕಲ್ಯಾಣ",
    [HEADING2]: "KSRTCಯಲ್ಲಿ ಕಾರ್ಮಿಕ ಕಲ್ಯಾಣ ಕ್ರಮಗಳನ್ನು ಜಾರಿಗೊಳಿಸಲಾಗಿದೆ",
    [P1]: "KSRTCಯು ನೌಕರರ ಅನುಕೂಲಕ್ಕಾಗಿ ಅನೇಕ ಕಾರ್ಮಿಕ ಕಲ್ಯಾಣ ಕ್ರಮಗಳನ್ನು ಪರಿಚಯಿಸಿದೆ.ಅವುಗಳಲ್ಲಿ ಕೆಲವು ಪ್ರಮುಖ ಯೋಜನೆಗಳನ್ನು ಕೆಳಗೆ ವಿವರಿಸಲಾಗಿದೆ:",
    [HEADING3]: "ವ್ಯಸನಮುಕ್ತ ಕೇಂದ್ರ:",
    [P2]: "ಒಂದು ಡಿ-ಅಡಿಕ್ಷನ್ ಪ್ರೋಗ್ರಾಂ, WAPPA (ಕೆಲಸದ ಸ್ಥಳ ಮದ್ಯಪಾನ ತಡೆಗಟ್ಟುವ ಕಾರ್ಯಕ್ರಮ ಮತ್ತು ಚಟುವಟಿಕೆ) ಅನ್ನು ಜಾರಿಗೊಳಿಸಲಾಗಿದೆ",
    [P3]: "1997 ರಿಂದ KSRTC ಕಾರ್ಮಿಕರನ್ನು ತಲುಪುವ ಕಾರ್ಯಕ್ರಮ. ನೀತಿಯ ಉದ್ದೇಶಗಳು:",
    [P4]: "ಆರೋಗ್ಯದ ಬಗ್ಗೆ ನಿಗಮಗಳ ಬದ್ಧತೆಯ ಭಾಗವಾಗಿ ಎಲ್ಲಾ ಉದ್ಯೋಗಿಗಳಲ್ಲಿ ಮದ್ಯದ ದುರುಪಯೋಗವನ್ನು ತಡೆಗಟ್ಟಲು",
    [P5]: "ಮತ್ತು ಅದರ ಉದ್ಯೋಗಿಗಳ ಕಲ್ಯಾಣ, ಕಾರ್ಯಾಚರಣೆಯ ಸುರಕ್ಷತೆ ಮತ್ತು ಪರಿಸರ.",
    [P6]: "ಮದ್ಯದ ದುರುಪಯೋಗದ ಅಪಾಯಗಳು ಮತ್ತು ಪರಿಣಾಮಗಳ ಬಗ್ಗೆ ವಿಶೇಷ ಆಸಕ್ತಿಯಿಂದ ಉದ್ಯೋಗಿಗಳಿಗೆ ಶಿಕ್ಷಣ ನೀಡುವುದು",
    [P7]: "ಪ್ರಯಾಣಿಕರ ಸುರಕ್ಷತೆ ಮತ್ತು ಈ ಅಭ್ಯಾಸವನ್ನು ಜಯಿಸಲು ಎಲ್ಲಾ ಉದ್ಯೋಗಿಗಳಿಗೆ ಸಹಾಯ ಮಾಡುತ್ತದೆ.",
    [HEADING4]:
      "ಬೆಂಗಳೂರು ಮತ್ತು ಮೈಸೂರಿನಲ್ಲಿ ಪ್ರಿವೆಂಟಿವ್ ಮೆಡಿಸಿನ್ ಮತ್ತು ಹೆಲ್ತಿ ಲೈಫ್ ಸ್ಟೈಲ್ ಕ್ಲಿನಿಕ್:",
    [P8]: "ಎಲ್ಲಾ ಉದ್ಯೋಗಿಗಳಿಗೆ ಸಮಗ್ರ ವಾರ್ಷಿಕ ಆರೋಗ್ಯ ತಪಾಸಣೆ ಕಾರ್ಯಕ್ರಮವನ್ನು ನೀಡಲು ಸ್ಥಾಪಿಸಲಾಗಿದೆ",
    [HEADING5]: "ವಿಮಾ ಯೋಜನೆ:",
    [P9]: "ಉದ್ಯೋಗಿ ಮತ್ತು ಉದ್ಯೋಗದಾತರ ಕೊಡುಗೆಯೊಂದಿಗೆ KSRTC ನೌಕರರ ಕುಟುಂಬ ಕಲ್ಯಾಣ ಯೋಜನೆ ಎಂಬ ಆಂತರಿಕ ವಿಮಾ ಯೋಜನೆಯನ್ನು ಪರಿಚಯಿಸಲಾಗಿದೆ, ಇದು ಸೇವೆಯಲ್ಲಿದ್ದಾಗ ಮರಣಹೊಂದಿದ ನೌಕರನ ಅವಲಂಬಿತರಿಗೆ ರೂ.3 ಲಕ್ಷಗಳ ಪರಿಹಾರವನ್ನು ನೀಡುತ್ತದೆ.",
    [HEADING6]: "ಮೆರಿಟ್ ಪ್ರಶಸ್ತಿಗಳು:",
    [P10]:
      "SSLC, PUC ಮತ್ತು ಪದವಿ ಪರೀಕ್ಷೆಗಳಲ್ಲಿ ಹೆಚ್ಚಿನ ಅಂಕಗಳನ್ನು ಗಳಿಸಿದ ಉದ್ಯೋಗಿ/ಅಧಿಕಾರಿಗಳ ಮಕ್ಕಳಿಗೆ",
    [HEADING7]: "ಶಿಕ್ಷಣಕ್ಕಾಗಿ ಸಾಲ:",
    [P11]:
      "ವೃತ್ತಿಪರ ಕೋರ್ಸ್‌ಗಳಿಗೆ ಪ್ರವೇಶ ಪಡೆದ ಉದ್ಯೋಗಿಗಳ ಮಕ್ಕಳಿಗೆ ಬೋಧನಾ ಶುಲ್ಕದ ಸೌಲಭ್ಯಕ್ಕಾಗಿ ಗರಿಷ್ಠ ರೂ.1 ಲಕ್ಷದವರೆಗೆ ಶಿಕ್ಷಣ ಸಾಲವನ್ನು ವಿಸ್ತರಿಸುವ ಯೋಜನೆ.",
    [HEADING8]: "ವೈದ್ಯಕೀಯ ಮರುಪಾವತಿ:",
    [P12]:
      "ಮರುಪಾವತಿಯನ್ನು ರಾಜ್ಯ ಸರ್ಕಾರಕ್ಕೆ ಸಮಾನವಾಗಿ ನೀಡಲಾಗುತ್ತದೆ. ಉದ್ಯೋಗಿ ಮತ್ತು ಅವರ ಅವಲಂಬಿತರ ಪ್ರಮುಖ ಅನಾರೋಗ್ಯ ಮತ್ತು ವೈಯಕ್ತಿಕ ಅನಾರೋಗ್ಯಕ್ಕೆ ಮುಂಗಡ.",
    [HEADING9]: "ಆಸ್ಪತ್ರೆಗಳ ಮಾನ್ಯತೆ:",
    [P13]:
      "ನೌಕರರಿಗೆ ಮತ್ತು ಅವರ ಅವಲಂಬಿತರಿಗೆ ಸಾಕಷ್ಟು ವೈದ್ಯಕೀಯ ಸೌಲಭ್ಯಗಳನ್ನು ಒದಗಿಸಲು 108 ಕ್ಕೂ ಹೆಚ್ಚು ಪ್ರತಿಷ್ಠಿತ ಖಾಸಗಿ ಆಸ್ಪತ್ರೆಗಳು ಮತ್ತು 7 ಡಯಾಗ್ನೋಸ್ಟಿಕ್ ಕೇಂದ್ರಗಳನ್ನು ನಿಗಮದಿಂದ ಗುರುತಿಸಲಾಗಿದೆ.",
    [HEADING10]: "ಶಿಕ್ಷಣಕ್ಕೆ ಸಹಾಯ :",
    [P14]:
      "ವಿವಿಧ ಕೋರ್ಸ್‌ಗಳಲ್ಲಿ ಓದುತ್ತಿರುವ ಉದ್ಯೋಗಿ/ಅಧಿಕಾರಿಗಳ ಮಕ್ಕಳಿಗೆ ತಿಂಗಳಿಗೆ ವಿದ್ಯಾರ್ಥಿವೇತನವನ್ನು ನೀಡುವ  ಯೋಜನೆ.",
    [HEADING11]: "ಪ್ರಶಸ್ತಿ ಯೋಜನೆಗಳು:",
    [P15]: "ನಿಗಮದ ಅಪಘಾತ ಮಾಡದ ಚಾಲಕರಿಗೆ ಚಿನ್ನ ಮತ್ತು ಬೆಳ್ಳಿ ಪದಕಗಳನ್ನು ನೀಡುವುದು.",
    [LI1_1]: "ಚಿನ್ನದ ಪದಕ:",
    [LI1_2]:
      "ಹದಿನೈದು ವರ್ಷಗಳ ಕಾಲ ಗ್ರಾಮೀಣ ಪ್ರದೇಶದಲ್ಲಿ ಮತ್ತು ಏಳು ವರ್ಷಗಳ ಕಾಲ ನಗರ ಸೇವೆಗಳಲ್ಲಿ ಅಪಘಾತ ರಹಿತ ಸೇವೆ ಸಲ್ಲಿಸಿದ ಚಾಲಕರಿಗೆ ನೀಡಲಾಗುತ್ತದೆ.",
    [LI2_1]: "ಬೆಳ್ಳಿ ಪದಕ:",
    [LI2_2]:
      "ಐದು ವರ್ಷಗಳ ಅಪಘಾತ-ಮಾಡದೇ ದಾಖಲೆ ಇರುವ ಚಾಲಕರಿಗೆ ಗ್ರಾಮೀಣ ಪ್ರದೇಶದಲ್ಲಿ ಮತ್ತು ಮೂರು ವರ್ಷಗಳ ಅಪಘಾತ-ಮುಕ್ತ ದಾಖಲೆಯನ್ನು ನಗರ ಸೇವೆಗಳಲ್ಲಿ ನೀಡಲಾಗುತ್ತದೆ.",
    [LI3_1]: "ಶೌರ್ಯ ಪ್ರಶಸ್ತಿ ಪದಕ ಯೋಜನೆ: ",
    [LI3_2]:
      "KSRTCಯಲ್ಲಿ ಶೌರ್ಯ ಪ್ರಶಸ್ತಿ ಯೋಜನೆಯನ್ನು ನಿರ್ದೇಶಕರ ಮಂಡಳಿಯ ಅನುಮೋದನೆಯಂತೆ ಪರಿಚಯಿಸಲಾಗಿದೆ, ದಿನಾಂಕ 25.11.09 ದಿನಾಂಕದ 25.11.09 ರ ನಿರ್ಣಯದ ಪ್ರಕಾರ ಗರಿಷ್ಠ ರೂ. 20,000/- ವರೆಗೆ ನಗದು ಪ್ರಶಸ್ತಿ ಮತ್ತು ಅರ್ಹತೆಗಾಗಿ ಚಿನ್ನದ ಪದಕವನ್ನು ನೀಡಲಾಗುತ್ತದೆ. / ಮಾದರಿಯ ಸೇವೆಗಳು ಮತ್ತು ಉದ್ಯೋಗದಾತರು ತಮ್ಮ ಸಮರ್ಥವಾದ ಕರ್ತವ್ಯಗಳನ್ನು ನಿರ್ವಹಿಸುವಾಗ ಸಲ್ಲಿಸಿದ ಸಮರ್ಪಣೆಯನ್ನು  ಪರಿಶೀಲಿಸಿದ ನಂತರ.",
    [HEADING12]: "ಕ್ರೀಡೆ ಮತ್ತು ಸಾಂಸ್ಕೃತಿಕ ಚಟುವಟಿಕೆಗಳು:",
    [P16]:
      "ಉದ್ಯೋಗಿಗಳಿಗೆ ವಿಭಾಗೀಯ ಮತ್ತು ಅಂತರ ವಿಭಾಗೀಯ ಕ್ರೀಡೆಗಳು ಮತ್ತು ಸಾಂಸ್ಕೃತಿಕ ಚಟುವಟಿಕೆಗಳನ್ನು ವಾರ್ಷಿಕವಾಗಿ ನಡೆಸಲಾಗುತ್ತದೆ.",
    [HEADING13]: "ಸಂಚಾರ ಆದಾಯ ಪ್ರೋತ್ಸಾಹ ಯೋಜನೆ:",

    [LI4]: "ಈ ಯೋಜನೆ ಚಾಲಕರು ಮತ್ತು ಕಂಡಕ್ಟರ್‌ಗಳಿಗೆ ಅನ್ವಯಿಸುತ್ತದೆ",
    [LI5]: "ನಗರ ಮತ್ತು ಉಪನಗರ ಸೇವೆಗಳಲ್ಲಿ, ಸಂಚಾರ ಆದಾಯ ಸಂಗ್ರಹಣೆಯಲ್ಲಿ 3%.",
    [LI6]:
      "ಸಾಮಾನ್ಯ, ಗ್ರಾಮೀಣ ಪ್ರದೇಶದ , ಎಕ್ಸ್‌ಪ್ರೆಸ್, ಅರೆ-ಐಷಾರಾಮಿ ಸೇವೆಗಳಿಗೆ ಸಂಬಂಧಿಸಿದಂತೆ, ಸಂಚಾರ ಆದಾಯದ 2%.",

    [HEADING14]: "ಸಲಹೆ",
    [P17]:
      "ಗರಿಷ್ಠ ಉತ್ಪಾದಕತೆಗಾಗಿ ಕಾರ್ಮಿಕ ಬಲವನ್ನು ಉತ್ತೇಜಿಸಲು KSRTC ಯಲ್ಲಿ ಸಲಹೆ ಅಥವಾ ಮಾರ್ಗದರ್ಶನದ ಯೋಜನೆಯನ್ನು ಜಾರಿಗೊಳಿಸಲಾಗಿದೆ. ಉತ್ಪಾದಕತೆಯನ್ನು ಹೆಚ್ಚಿಸುವ ಮೂಲಕ, ಅಪಘಾತದ ದರದಲ್ಲಿನ ಕಡಿಮೆ ಮತ್ತು ಪ್ರಯಾಣಿಕರೊಂದಿಗೆ ಉದ್ಯೋಗಿಗಳ ನಡವಳಿಕೆಯನ್ನು ಸುಧಾರಿಸುವ ಮೂಲಕ ಗೈರುಹಾಜರಿಯನ್ನು ಕಡಿಮೆ ಮಾಡಲು ಇದು ಸಹಾಯ ಮಾಡುತ್ತದೆ.",
    [HEADING15]: "ಸ್ವಯಂ ನಿವೃತ್ತಿ ಯೋಜನೆ:",
    [P18]:
      "12.08.2005 ರಿಂದ ಸ್ವಯಂ ನಿವೃತ್ತಿ ಯೋಜನೆಯನ್ನು ಜಾರಿಗೊಳಿಸಲಾಗಿದೆ. ಯೋಜನೆಯಡಿಯಲ್ಲಿ ಸ್ವಯಂ ನಿವೃತ್ತಿಯನ್ನು ಆರಿಸಿಕೊಳ್ಳುವ ಉದ್ಯೋಗಿಯು ರೂ.75,000/- ರಿಂದ ರೂ.2,00,000/- ವರೆಗಿನ ಹೆಚ್ಚುವರಿ ಆರ್ಥಿಕ ಪ್ರಯೋಜನವನ್ನು ಪಡೆಯುತ್ತಾನೆ. ಅಕ್ಟೋಬರ್ 2010 ರಿಂದ ಜಾರಿಗೆ ಬರುವಂತೆ ಕನಿಷ್ಠ ಪ್ರಯೋಜನವನ್ನು ರೂ.1,25,000/- ಕ್ಕೆ ಹೆಚ್ಚಿಸಲಾಗಿದೆ.",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
